import { render } from "./ThemeToggle.vue?vue&type=template&id=bfd86fa0&scoped=true"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"

import "./ThemeToggle.vue?vue&type=style&index=0&id=bfd86fa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd86fa0"]])

export default __exports__